export enum ACTIONS {
  SET_HISTORY = 'SET_HISTORY',
  GET_HISTORY = 'GET_HISTORY',
}

export interface IHistory {
  history: any[] | null;
}
